(() => {
  if (customElements.get('ns-cart-extras')) return;

  const drafts = new Map();

  customElements.define('ns-cart-extras', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.draftKey = this.dataset.formId || 'CartDrawer';
      this.seller = this.querySelector('input[name="attributes[Sælger ID]"]');

      if (this.seller && drafts.has(this.draftKey)) {
        this.seller.value = drafts.get(this.draftKey);
      }

      const options = { signal: this.controller.signal };
      const saveSeller = (event) => {
        if (event.target === this.seller) drafts.set(this.draftKey, this.seller.value);
      };
      this.addEventListener('input', saveSeller, options);
      this.addEventListener('change', saveSeller, options);
    }

    disconnectedCallback() {
      if (this.seller) drafts.set(this.draftKey, this.seller.value);
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
